import styles from "../index.module.scss";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIcon from "./DragIcon.svg";
import Close from "./Close.svg";
import EditIcon from "./EditIcon.svg";
import DeleteIcon from "./DeleteIcon.svg";
import CopyIcon from "./CopyIcon.svg";

export default function DragConfig({
  containerArray,
  setContainerArray,
  isQuestion = false,
  setAvailAttr,
  handleDelete,
  handleCopy,
  stage,
  handleEdit,
}) {
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(containerArray);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);

    setContainerArray(reordered);
  };

  const AttributeComp = ({ attribute, mandate, index }) => {
    return (
      <div className={`${styles.dragAttribue} ${stage !== 1 ? `${styles.dragNone}` : ""}`}>
        <div className={styles.dragRow}>
          {stage ===1 && <img src={DragIcon} alt="dragIcon" />}
          <div className={styles.dragRowTitle}>
            <div>{index + 1}. </div>
            {attribute}
          </div>
        </div>
        {!mandate && (
          <img
            className={styles.dragCross}
            onClick={() => {
              setContainerArray((prev) =>
                prev.filter((i) => i.attribute !== attribute)
              );
              setAvailAttr((prev) => [...prev, attribute]);
            }}
            src={Close}
            alt="close"
          />
        )}
      </div>
    );
  };

  const optionMapping = {
    1: "A",
    2: "B",
    3: "C",
    4: "D",
    5: "E",
    6: "F",
  };

  const QuestionComp = ({
    item,
    questionId,
    question,
    options,
    answer,
    ansId,
    marks,
    idx,
  }) => {
    return (
      <div className={styles.dragQuestion}>
        <div className={styles.dragQuestionRow}>
          <img src={DragIcon} alt="dragIcon" />
          <div className={styles.dragQuestionView}>
            <div>{`Q${idx + 1}.`}</div>
            <textarea readOnly>{question}</textarea>
          </div>
          <img
            className={styles.cursorPointer}
            onClick={() => handleEdit(item)}
            src={EditIcon}
            alt="Edit"
          />
          <img
            className={styles.cursorPointer}
            onClick={() => handleCopy(item)}
            src={CopyIcon}
            alt="Copy"
          />
          <img
            className={styles.cursorPointer}
            onClick={() => handleDelete(questionId, marks)}
            src={DeleteIcon}
            alt="Delete"
          />
        </div>
        <div className={styles.quesOptnList}>
          {options.map((i, index) => (
            <div key={index} className={styles.dragOption}>
              <div className={styles.dragOptionIndex}>
                {`${optionMapping[index + 1]})`}
              </div>
              <div className={styles.dragOptionText}>{i.option_text}</div>
            </div>
          ))}
        </div>
        <div className={styles.dragAnswerInfo}>
          <div className={styles.dragAnswerPlaceHolder}>Correct Answer :</div>
          <div className={styles.dragAnswerIndex}>
            {(() => {
              const index = options.findIndex((i) => i.option_id === ansId);
              if (index !== -1) {
                return `${String.fromCharCode(65 + index)})`; 
              }
              return ""; 
            })()}
          </div>
          <div className={styles.dragAnswerTitle}>{answer}</div>
          <div className={styles.dragAnswerMarks}>{marks} marks</div>
        </div>
      </div>
    );
  };

  return (
    <section className={styles.dragContainer}>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="attributes">
          {(provided) => (
            <div
              {...provided.droppableProps}
              className={styles.DragAttrList}
              ref={provided.innerRef}
            >
              {containerArray.map((item, index) => (
                <Draggable
                  key={isQuestion ? String(item.questionId) : item.attribute}
                  draggableId={
                    isQuestion
                      ? String(item.questionId)
                      : stage === 1
                      ? item.attribute
                      : ""
                  }
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={provided.draggableProps.style}
                    >
                      {isQuestion ? (
                        <div
                          className={styles.dragKit}
                          {...provided.dragHandleProps}
                        >
                          <QuestionComp
                            idx={index}
                            item={item}
                            questionId={item.questionId}
                            question={item.questionText}
                            options={item.answerList}
                            answer={item.answer}
                            marks={item.marks}
                            ansId={item.answerId}
                          />
                        </div>
                      ) : (
                        <div
                          className={stage === 1 ? styles.dragKit : ""}
                          {...provided.dragHandleProps}
                        >
                          <AttributeComp
                            index={index}
                            attribute={item.attribute}
                            mandate={item.mandate}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </section>
  );
}
